export const initialBudgetItems = [
  {
    id: 'digital-1',
    category: 'Digital Promotion',
    name: 'Pre-conference email campaign',
    detail: 'Dedicated member email distribution',
    quantity: 2,
    rate: 3200,
    enabled: true
  },
  {
    id: 'digital-2',
    category: 'Digital Promotion',
    name: 'Society website leaderboard',
    detail: 'Homepage placement for four weeks',
    quantity: 1,
    rate: 5500,
    enabled: true
  },
  {
    id: 'digital-3',
    category: 'Digital Promotion',
    name: 'Mobile app sponsored placement',
    detail: 'Featured tile and push notification',
    quantity: 1,
    rate: 6800,
    enabled: true
  },
  {
    id: 'digital-4',
    category: 'Digital Promotion',
    name: 'Social media promotion',
    detail: 'Paid and society-owned channels',
    quantity: 1,
    rate: 4200,
    enabled: false
  },
  {
    id: 'onsite-1',
    category: 'Onsite Visibility',
    name: 'Registration area signage',
    detail: 'High-traffic arrival placement',
    quantity: 2,
    rate: 4500,
    enabled: true
  },
  {
    id: 'onsite-2',
    category: 'Onsite Visibility',
    name: 'Directional floor graphics',
    detail: 'Branded wayfinding placements',
    quantity: 6,
    rate: 950,
    enabled: true
  },
  {
    id: 'onsite-3',
    category: 'Onsite Visibility',
    name: 'Escalator or column branding',
    detail: 'Premium venue visibility',
    quantity: 1,
    rate: 12500,
    enabled: false
  },
  {
    id: 'onsite-4',
    category: 'Onsite Visibility',
    name: 'Charging lounge sponsorship',
    detail: 'Branded attendee recharge area',
    quantity: 1,
    rate: 14500,
    enabled: false
  },
  {
    id: 'sponsor-1',
    category: 'Education & Sponsorship',
    name: 'Industry-supported symposium',
    detail: 'Room, listing, and promotional package',
    quantity: 1,
    rate: 28000,
    enabled: true
  },
  {
    id: 'sponsor-2',
    category: 'Education & Sponsorship',
    name: 'Poster hall sponsorship',
    detail: 'Branding near scientific posters',
    quantity: 1,
    rate: 17500,
    enabled: false
  },
  {
    id: 'sponsor-3',
    category: 'Education & Sponsorship',
    name: 'Coffee break sponsorship',
    detail: 'Recognition and service-area signage',
    quantity: 1,
    rate: 9800,
    enabled: true
  },
  {
    id: 'print-1',
    category: 'Print & Production',
    name: 'Program guide advertisement',
    detail: 'Full-page color placement',
    quantity: 1,
    rate: 5200,
    enabled: true
  },
  {
    id: 'print-2',
    category: 'Print & Production',
    name: 'Creative adaptation and design',
    detail: 'Conference-specific production support',
    quantity: 24,
    rate: 175,
    enabled: true
  },
  {
    id: 'print-3',
    category: 'Print & Production',
    name: 'Freight, install, and dismantle',
    detail: 'Venue handling and labor estimate',
    quantity: 1,
    rate: 7400,
    enabled: true
  }
];

export const categoryMeta = {
  'Digital Promotion': {
    color: '#1c8c86',
    description: 'Pre-event, web, app, email, and social inventory'
  },
  'Onsite Visibility': {
    color: '#4e74ce',
    description: 'Venue signage, attendee services, and high-traffic placements'
  },
  'Education & Sponsorship': {
    color: '#8b6ac8',
    description: 'Symposia, scientific programming, and sponsored experiences'
  },
  'Print & Production': {
    color: '#db8b3e',
    description: 'Printed media, creative services, labor, and logistics'
  }
};

export const presets = {
  Essential: {
    budget: 50000,
    enabledIds: [
      'digital-1',
      'digital-2',
      'onsite-1',
      'print-1',
      'print-2',
      'print-3'
    ]
  },
  Balanced: {
    budget: 100000,
    enabledIds: [
      'digital-1',
      'digital-2',
      'digital-3',
      'onsite-1',
      'onsite-2',
      'sponsor-1',
      'sponsor-3',
      'print-1',
      'print-2',
      'print-3'
    ]
  },
  Premier: {
    budget: 175000,
    enabledIds: initialBudgetItems.map((item) => item.id)
  }
};